/* global Raven:true */
'use strict';

/**
 * @ngdoc overview
 * @name gfcmsApp
 * @description
 * # gfcmsApp
 *
 * Main module of the application.
 */
angular
  .module('gfcmsApp', [
    'ngAnimate',
    'ngAria',
    'ngCookies',
    'ngMessages',
    'ngResource',
    'ngRoute',
    'ngSanitize',
    'ngTouch',
    'angularMoment',
    'LocalStorageModule',
    'ui.bootstrap',
    'cfp.loadingBar',
    'cfp.loadingBarInterceptor',
    'ngBackstretch',
    'toastr',
    '720kb.datepicker',
    'angular-nicescroll',
    // 'firebase',
    'uuid4',
    'ui.calendar',
    'ngFileUpload',
    'ngImgCrop',
    'vcRecaptcha',
    'ngFileSaver'
  ])
  .config(['cfpLoadingBarProvider', '$cookiesProvider',
    'moment', 'appSettings', 'toastrConfig', 'vcRecaptchaServiceProvider',
    function(cfpLoadingBarProvider, $cookiesProvider,
      moment, appSettings, toastrConfig, vcRecaptchaServiceProvider) {

      Raven.config(appSettings.sentry.DSN).install();
      Raven.setTagsContext({environment: appSettings.sentry.environment});

      angular.extend(toastrConfig, {
        preventOpenDuplicates: false
      });

      vcRecaptchaServiceProvider.setSiteKey(appSettings.google.recaptcha.siteKey);
      cfpLoadingBarProvider.includeSpinner = false;
    }
  ])
  .config(function($httpProvider) {
    $httpProvider.interceptors.push('authInterceptorService');
  })
  .run(['$rootScope', '$location', '$cookies', '$http', 'localStorageService',
   'eventsService', 'appSettings','permissionService', 'ravenService',
    function($rootScope, $location, $cookies, $http, localStorageService,
      eventsService, appSettings, permissionService, ravenService) { // jshint ignore: line
      $rootScope.user = {
        username: 'melvin',
        imageUrl: '/images/profile.png'
      };
      var config = {
        apiKey: appSettings.firebase.apiKey,
        authDomain: appSettings.firebase.authDomain,
        databaseURL: appSettings.firebase.databaseURL,
        storageBucket: appSettings.firebase.storageBucket
      };

      // firebase.initializeApp(config); //jshint ignore:line
      eventsService.initializeOnBeforeUnload();

      // keep user logged in after page refresh
      $rootScope.authData = localStorageService.get('authorizationData');
      if ($rootScope.authData) {
        $rootScope.loggedIn = true;
        ravenService.loggedIn({
          username: $rootScope.authData.userName,
          requiresTfa: $rootScope.authData.requiresTfa
        });
        permissionService.Permissions()
        .then(function (response) {
          console.info('Permissions Loaded!');
        });
      }

      eventsService.subscribe(eventsService.routeChangeStartEvent, function(scope, next, current) {
        var permission = next.$$route.permission;
        var pathNotFound = next.$$route.originalPath === '/404';
        var loggedIn = localStorageService.get('authorizationData');

        if (!permissionService.permissionsLoaded() && loggedIn) {
          permissionService.Permissions()
          .then(function (response) {
            if (!!permission && !permissionService.hasPermission(permission) && !pathNotFound) {
              $location.path('/404');
            } else {
            var route = next.$$route;
            var path = route.originalPath;
            if (!angular.equals(!!next.params, {})) {
              for (var key in next.params) {
                if (next.params.hasOwnProperty(key)) {
                  path = path.replace(':' + key, next.params[key]);
                }
              }
            }
            $location.path(path);
            }
          });

          if (!!event)
          {
            event.preventDefault();
          }
        }
        else {
          if (permission && !permissionService.hasPermission(permission) && !pathNotFound) {
            $location.path('/404');
          }
        }
      });

      eventsService.subscribe(eventsService.locationChangeStartEvent, function() {
        var loggedIn = localStorageService.get('authorizationData');

        if (loggedIn) {
          $rootScope.loggedIn = true;
        } else {
          eventsService.loggedOut();
          var currentUrl = $location.url();
          var isLogin = currentUrl.indexOf('/login') > -1;
          if (isLogin) {
            $location.href = decodeURIComponent($location.absUrl());
          } else {
            $location.path('/login').search('returnUrl', currentUrl);
          }
        }
      });

    }
  ]);
